import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
export { default as FormInputEmail } from './FormInputEmail';
var EMAIL_VALIDATION_URL = 'https://valid.ropto.com/email/';
export var emailRegex = /^((?!\.{2,}|^\.|\.@)[a-zA-Z0-9._%+-])+@[a-z0-9.-]+\.[a-z]{2,12}$/;
export var emailAdvancedValidation = function emailAdvancedValidation(email) {
  return new Promise(function (resolve, reject) {
    var parsedEmail = email.replace(/\s/g, '');
    var fetchResponse = {};

    try {
      fetch("" + EMAIL_VALIDATION_URL + parsedEmail).then(function (response) {
        if (!response) {
          return reject(new Error('Failed to validate email: no response received'));
        }

        fetchResponse = Object.assign({}, response);

        if (response.status < 200 || response.status >= 300) {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(fetchResponse));
          return reject(new Error('Failed to validate email: status code not in 2xx range'));
        }

        return response.json();
      }).then(function (data) {
        if (!data.success) {
          return resolve({
            valid: false
          });
        }

        return resolve({
          valid: true
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(JSON.stringify(fetchResponse));
      throw new Error("Failed to validate email: " + error);
    }
  });
};